/**
 * Helper to get or create a global portal root for EVO modals/popovers.
 * This ensures modals render at the document.body level (not constrained by parent containers)
 * while still being inside a .evo-wrapper element so Tailwind styles apply.
 */

let evoPortalRoot: HTMLElement | null = null;

export function getEvoPortalRoot(): HTMLElement | null {
  if (typeof document === 'undefined') return null;
  
  // Return cached reference if it's still in the DOM
  if (evoPortalRoot && document.body.contains(evoPortalRoot)) {
    return evoPortalRoot;
  }

  // Check if the element already exists
  let el = document.getElementById('evo-modal-root') as HTMLElement | null;
  
  if (!el) {
    // Create the portal root element
    el = document.createElement('div');
    el.id = 'evo-modal-root';
    el.classList.add('evo-wrapper');
    document.body.appendChild(el);
  }
  
  evoPortalRoot = el;
  return evoPortalRoot;
}
